export enum METHOD {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

export enum ROLE {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  USER = 'USER',
}

export const ANONYMUS_USER_ID = 1515151515;
export const BASE_URL = 'http://localhost:8080/api/v1';
export const NUMBER_OF_DISPLAYED_PLAYGROUNDS = 4;
export const PLAYGROUND_SEARCH_BACKEND_PRODUCTION_URL =
  'https://playground-search-backend.vercel.app/api/v1';
